import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_ITINERARIES](state, data) {
    state.allItineraries = data
  },
}
